import * as Long from "long";
import * as React from "react";
import { IdResource } from "../../../constants/IdResource";
import { IdTooltipAdjust } from "../../../constants/IdTooltipAdjust";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { utilBuff } from "../../../utils/utilBuff";
import { ButtonDefault } from "../../generic/button-buy/ButtonDefault";
import { ButtonSecondary } from "../../generic/common/ButtonSecondary";
import { IdIcon } from "../../generic/icon/IdIcon";
import { TypeNumberRounding } from "../../generic/round-format/TypeNumberRounding";
import { TextLoca } from "../../generic/text/TextLoca";
import { IdTooltipAnchor, TooltipText } from "../../tooltip";
import { ExpansionGridImage } from "./GraphicExpansion";
export var PremiumPurchaseBuyExpansions = function (_a) {
    var expansionDiscountBuff = _a.expansionDiscountBuff, expansionTypeInfo = _a.expansionTypeInfo, expansionsSizeX = _a.expansionsSizeX, expansionsSizeY = _a.expansionsSizeY, onBuyExpansion = _a.onBuyExpansion;
    var resources = expansionTypeInfo.resources, levelLock = expansionTypeInfo.levelLock;
    var premiumResource = resources.find(function (item) { return item.resource.id === IdResource.Gold; });
    var amount = premiumResource ? premiumResource.cost : Long.ZERO;
    var buffedAmount = expansionDiscountBuff
        ? utilBuff.applyTo(amount, expansionDiscountBuff, TypeNumberRounding.Ceil)
        : undefined;
    return (React.createElement("div", { className: "expansion-menu__premium " + IdStyles.BuyExpansionPremiumBackground },
        React.createElement(ExpansionGridImage, { expansionsSizeX: expansionsSizeX, expansionsSizeY: expansionsSizeY }),
        React.createElement("div", { className: IdStyles.TextBoldPrimary },
            React.createElement(TextLoca, { id: IdLoca.expansionDialog_unlock })),
        React.createElement(TooltipText, { id: IdLoca.tooltip_buyForGold_web, anchor: IdTooltipAnchor.Bottom, adjustVertical: IdTooltipAdjust.Large },
            React.createElement(ButtonDefault, { component: ButtonSecondary, icon: IdIcon.GoldIcn, amount: amount, buffedAmount: buffedAmount, onClick: function () {
                    return onBuyExpansion(buffedAmount !== undefined ? buffedAmount : amount);
                }, disabled: levelLock }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/expansions/PremiumPurchaseBuyExpansions.tsx
// module id = 2866
// module chunks = 3